import { Component, input } from '@angular/core';

export type BasicBadgeVariant = 'default' | 'amber' | 'success' | 'danger' | 'primary';

@Component({
  selector: 'idel-basic-badge',
  templateUrl: './basic-badge.component.html',
  styleUrl: './basic-badge.component.scss',
})
export class BasicBadgeComponent {
  public readonly value = input.required<string>();
  public readonly variant = input<BasicBadgeVariant>('default');
}
